import { Component, Input, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';

import { ApAmountDisplayComponent, ApCurrencyService } from '@ap/amounts';
import { ApContentModule, ApContentService } from '@ap/content';
import { Betaalverzoek, Crediteur } from '@ap/interface-apic-betaalverzoek';
import { ApAccordionComponent, ApAccordionItemComponent } from '@ap/accordion';
import { ApIbanPipe } from '@ap/formatters';
import { ApKeyValueModule } from '@ap/key-value';

import sharedContent from '../shared.content.json';

import content from './payment-request-details.content.json';

/**
 * @ngdoc component
 * @name PaymentRequestDetailsComponent
 *
 * @description
 * Component that provides functionality to display payment-request details
 */
@Component({
    selector: 'payment-request-details',
    templateUrl: './payment-request-details.component.html',
    imports: [
        ApAccordionComponent,
        ApAccordionItemComponent,
        ApContentModule,
        ApAmountDisplayComponent,
        ApIbanPipe,
        ApKeyValueModule,
        CommonModule
    ]
})
export class PaymentRequestDetailsComponent implements OnInit {
    @Input()
    public betaalverzoek: Betaalverzoek;

    public constructor(
        private readonly apCurrencyService: ApCurrencyService,
        private readonly contentService: ApContentService
    ) {}

    public ngOnInit(): void {
        this.contentService.addContentItems(content);
        this.contentService.addContentItems(sharedContent);
    }

    public getItemTitle(): string {
        return this.contentService.interpolate(this.contentService.get('payment-request.details.accordion.label'), {
            description: this.betaalverzoek.omschrijving,
            amount: this.apCurrencyService.transform(this.betaalverzoek.bedrag.bedrag, 'EUR', 'symbol', undefined, 'nl-NL'),
            name: this.getWeergavenaam(this.betaalverzoek.crediteur)
        });
    }

    public getWeergavenaam(crediteur: Crediteur): string {
        return crediteur?.weergavenaam ?? this.contentService.get('payment-request.details.fallback.name-not-available');
    }
}
